var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLaptop = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Laptop"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M14.9514 12.2076L14.0061 8.87793V1.62793C14.0061 1.35137 13.7826 1.12793 13.5061 1.12793H2.50607C2.22951 1.12793 2.00607 1.35137 2.00607 1.62793V8.87793L1.06076 12.2076C0.943572 12.5342 1.1842 12.8779 1.53107 12.8779H14.4811C14.8279 12.8779 15.0686 12.5342 14.9514 12.2076ZM3.13107 2.25293H12.8811V8.4248H3.13107V2.25293ZM6.69826 11.7529L6.82482 11.1748H9.17326L9.29982 11.7529H6.69826ZM10.1983 11.7529L9.89982 10.3982C9.88732 10.3404 9.83576 10.2998 9.77795 10.2998H6.2217C6.16232 10.2998 6.11232 10.3404 6.09982 10.3982L5.80138 11.7529H2.3592L3.02013 9.4248H12.992L13.6529 11.7529H10.1983Z",
  strokeWidth: 0.3
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLaptop);
export default ForwardRef;